import { Component } from '@angular/core';

/** Loading placeholder shaped like this page: six month cards, then the taller declined card. */
@Component({
  selector: 'ifbp-partner-scorecard-skeleton',
  templateUrl: './partner-scorecard-skeleton.component.html',
  styleUrls: ['./partner-scorecard-skeleton.component.scss'],
  standalone: false,
})
export class PartnerScorecardSkeletonComponent {
  readonly monthCards = [0, 1, 2, 3, 4, 5];
  readonly monthTheme = { height: '22rem', 'border-radius': '0.5rem', margin: 0 };
  readonly declinedTheme = { height: '41.5rem', 'border-radius': '0.75rem', margin: 0 };

  trackByIndex(index: number): number {
    return index;
  }
}
